module.exports = __webpack_public_path__ + "static/media/hash.d04432d6.svg";